import { loadMicroApp } from "qiankun";
import { clearAccountInfo } from "@utils/auth";

class MicroApp {
  constructor() {
    this.isMounted = false
  }
  load (container, props = {}) {
    this.microApp = loadMicroApp(
      {
        name: "dots_microservice",
        entry: process.env.REACT_APP_MICRO_URL || '/micro/',
        container,
        props: {
          baseURL: process.env.REACT_APP_MICRO_URL || '', // 传递环境变量
          locale: localStorage.getItem("language_type") || "zh_CN",//语言
          microData: props,
          toLogin: () => {
            clearAccountInfo();
            window.location.href = `${window.location.origin}/login`;
          },
          parentWindow: window,
        },
      }
    );
    this.microApp.mountPromise.then(() => {
      this.isMounted = true
    })
  }
  unload () {
    if (this.microApp && this.isMounted) {
      this.isMounted = false
      this.microApp.unmount();
    }
  }


}

export default new MicroApp()
